import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useEconomicCalendarBehindTheDataContent } from '../../../../hooks/useEconomicCalendarBehindTheDataContent';
import './BehindTheData.css';

const BehindTheData = () => {
  const { content, isLoading } = useEconomicCalendarBehindTheDataContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="behind-the-data">
      <div className="behind-the-data__inner">
        <Reveal className="behind-the-data__content">
          <h2 className="behind-the-data__title">{title}</h2>
          {text ? <p className="behind-the-data__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="behind-the-data__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default BehindTheData;
